module.exports = __webpack_public_path__ + "static/media/frontDeskActive.741836b9.svg";